export enum ImageViewsEnum {
	EXTERIOR_FRONT_3_4 = 'ngccfront34desktopxl',
	LIGHTS_FRONT_HEADLIGHTS = 'ngccheadlightdesktopxl',
	EXTERIOR_FRONT_FRONT = 'ngccfrontdesktopxl',
	EXTERIOR_REAR_3_4 = 'ngccrear34desktopxl',
	EXTERIOR_REAR_REAR = 'ngccreardesktopxl',
	EXTERIOR_PARALLEL_SIDE = 'ngccsidedesktopxl',
	INTERIOR_SEATS_SEATS = 'ngccfrontseatsdesktopxl',
	INTERIOR_REAR_REARSEATS = 'ngccrearseatsdesktopxl',
	INTERIOR_DASHBOARD_DASHBOARD = 'ngccdashboarddesktopxl',
	EXTERIOR_WHEELS_RIM = 'ngccrimdesktopxl',
	EXTERIOR_REAR_TRUNK = 'ngcctrunkdesktopxl',
}

export const imageViews = Object.values(ImageViewsEnum);

export type ImageViews = (typeof imageViews)[number];
export const ImageViewsList: string[] = Object.values(ImageViewsEnum);
export const ImageViewsListWithENV: string[] = [
	...ImageViewsList,
	...ImageViewsList.map((img) => img.replace(/xl$/, 'env1xl')),
];
